import { TreeElement } from '../models/treeElement.model';

// Function that returns a nested node's list of children
export function getNodeChildren({ children }: TreeElement) {
  return children;
}
